'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import AdminActivityManagement from './components/AdminActivityManagement';

export default function AdminActivitiesPage() {
  return (
    <AppLayout activePath="/admin/activities">
      <AdminActivityManagement />
    </AppLayout>
  );
}
